module.exports = __webpack_public_path__ + "img/stickers-photos-bien.9af81184.jpg";